<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">Recurring tasks</h4>
        <button *ngIf="canManage" class="btn btn-primary btn-sm" (click)="openModal()" [disabled]="loadingService.isLoading()">
          <i class="bi bi-plus-circle me-1"></i> New template
        </button>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Title</th><th>Type</th><th>Assignee</th><th>Property</th><th>Frequency</th>
                <th>Next run</th><th>Created</th><th>Active</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loadingService.isLoading()">
                <td colspan="9" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
                </td>
              </tr>
              <tr *ngIf="!loadingService.isLoading() && recurrences.length === 0">
                <td colspan="9" class="text-center py-4">No recurring templates yet</td>
              </tr>
              <tr *ngFor="let r of recurrences">
                <td>
                  <strong>{{ r.title }}</strong>
                  <div class="subline" *ngIf="r.checklist?.length">Checklist · {{ r.checklist?.length }} items</div>
                </td>
                <td>{{ r.task_type }}</td>
                <td>{{ r.assignee?.name || '—' }}</td>
                <td>{{ r.property?.name || '—' }}</td>
                <td>
                  {{ frequencyLabel(r) }}
                  <div class="subline">from {{ r.start_date | date: 'd MMM yyyy' }}<span *ngIf="r.end_date"> to {{ r.end_date | date: 'd MMM yyyy' }}</span></div>
                </td>
                <td>{{ r.next_run_at ? (r.next_run_at | date: 'd MMM yyyy') : '—' }}</td>
                <td>
                  {{ r.created_count || 0 }}
                  <div class="subline" *ngIf="r.last_created_at">last {{ r.last_created_at | date: 'd MMM' }}</div>
                </td>
                <td>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [checked]="r.is_active" [disabled]="!canManage" (change)="toggleActive(r)" />
                  </div>
                </td>
                <td>
                  <div class="d-flex" *ngIf="canManage">
                    <button class="btn btn-info shadow btn-xs sharp me-1" (click)="openModal(r)" title="Edit"><i class="fa fa-pencil"></i></button>
                    <button class="btn btn-danger shadow btn-xs sharp me-1" (click)="delete(r)" title="Delete"><i class="fa fa-trash"></i></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="dataTables_info">{{ total }} template{{ total === 1 ? '' : 's' }}</div>
          <app-pagination [page]="page" [totalPage]="totalPage" (newPage)="pageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create / edit offcanvas -->
<div #recurrenceModal class="offcanvas offcanvas-end customeoff {{ showModal ? 'show' : '' }}" tabindex="-1" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title">{{ isEditMode ? 'Edit recurring template' : 'New recurring template' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"><i class="fa-solid fa-xmark"></i></button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="form" (ngSubmit)="submit()" autocomplete="off">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label">Title <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="title" [class.is-invalid]="isFieldInvalid('title')" placeholder="e.g. Monthly rent collection" />
            <div class="invalid-feedback" *ngIf="isFieldInvalid('title')">Title is required</div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Type <span class="text-danger">*</span></label>
            <ng-select [items]="typeOptions" bindValue="value" bindLabel="label" placeholder="Select type" class="select2" formControlName="task_type" [clearable]="false"></ng-select>
            <div class="text-danger small" *ngIf="isFieldInvalid('task_type')">Type is required</div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Priority</label>
            <select class="form-select" formControlName="priority">
              <option *ngFor="let o of priorityOptions" [value]="o.value">{{ o.label }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Assignee <span class="text-danger">*</span></label>
            <ng-select [items]="users.items" bindValue="value" bindLabel="label" placeholder="Select assignee" class="select2"
              formControlName="assignee_id" [typeahead]="users.search$" [virtualScroll]="true" (scrollToEnd)="users.scrollEnd()" [clearable]="false"></ng-select>
            <div class="text-danger small" *ngIf="isFieldInvalid('assignee_id')">Assignee is required</div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Property</label>
            <ng-select [items]="properties.items" bindValue="value" bindLabel="label" placeholder="Optional" class="select2"
              formControlName="property_id" [typeahead]="properties.search$" [virtualScroll]="true" (scrollToEnd)="properties.scrollEnd()"></ng-select>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Frequency <span class="text-danger">*</span></label>
            <select class="form-select" formControlName="frequency">
              <option *ngFor="let o of frequencyOptions" [value]="o.value">{{ o.label }}</option>
            </select>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Every</label>
            <input type="number" min="1" class="form-control" formControlName="interval" />
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Due after (days)</label>
            <input type="number" min="0" class="form-control" formControlName="due_after_days" />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Start date <span class="text-danger">*</span></label>
            <input type="date" class="form-control" formControlName="start_date" [class.is-invalid]="isFieldInvalid('start_date')" />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">End date</label>
            <input type="date" class="form-control" formControlName="end_date" [min]="form.value.start_date" />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Planned start</label>
            <input type="time" class="form-control" formControlName="planned_start" />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Planned end</label>
            <input type="time" class="form-control" formControlName="planned_end" />
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" formControlName="description"></textarea>
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Checklist</label>
            <div class="input-group input-group-sm mb-1" *ngFor="let item of checklist; let i = index; trackBy: trackByIndex">
              <input type="text" class="form-control" [(ngModel)]="checklist[i]" [ngModelOptions]="{ standalone: true }" />
              <button class="btn btn-outline-danger" type="button" (click)="removeChecklistItem(i)"><i class="fa fa-times"></i></button>
            </div>
            <div class="input-group input-group-sm mt-2">
              <input type="text" class="form-control" placeholder="Add a checklist item" [(ngModel)]="newChecklistLabel"
                [ngModelOptions]="{ standalone: true }" (keydown.enter)="$event.preventDefault(); addChecklistItem()" />
              <button class="btn btn-outline-primary" type="button" (click)="addChecklistItem()">Add</button>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" id="rec-active" formControlName="is_active" />
              <label class="form-check-label" for="rec-active">Active</label>
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit" [disabled]="form.invalid || loadingService.isLoading()">
            {{ isEditMode ? 'Update template' : 'Create template' }}
          </button>
          <button class="btn btn-danger light me-1" type="button" (click)="closeModal()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
@if (showModal) {
<div class="offcanvas-backdrop fade show" (click)="closeModal()"></div>
}
